import React from 'react'

import type { RevenueQuarter } from '../types/executives'
const Quater = ({ revenueQuarter }: { revenueQuarter: RevenueQuarter[] }) => {
    if (!revenueQuarter || revenueQuarter.length === 0) return null
    return (
        <div className="col-12">
            <div className="row gutters-18">
                {revenueQuarter.map((quater, index) => (
                    <div className="col-xl-3 col-md-6" key={index}>
                        <div className="card card-shadow card-seo">
                            <div className="card-body">
                                <div className="card-seo-info">
                                    <div className="seo-title">
                                        <span className="name">
                                            Q{quater.quarter} {quater.year}{' '}
                                            Revenue
                                        </span>
                                    </div>
                                    <h1 className="seo-stat-title">
                                        <sup className="currency">$</sup>
                                        {quater.totalRevenue}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Quater
